import { FunctionComponent, useState } from 'react'
import { useNavigate } from 'react-router'
import { Alert } from 'react-bootstrap'

import Page from 'components/ui/page'
import PageHeader from 'components/ui/pageHeader'
import HospitalForm from './components/hospitalForm'
import * as api from './api.client'
import { NewHospital } from './types'
import { removeAlphabeticCharacteres } from '../../utilities/string.util'
import { AppMessage } from '../../utilities/messages'

const newHospitalInitialState: NewHospital = {
  name: '',
  cnpj: '',
  enabled: false,
}

const AddHospital: FunctionComponent = () => {
  const navigate = useNavigate()
  const [hospital, setHospital] = useState(newHospitalInitialState)
  const [showFormErrors, setShowFormErrors] = useState(false)
  const [saving, setSaving] = useState(false)
  const [appMessage, setAppMessage] = useState<AppMessage>({ show: false })

  const addHospital = async (event: React.ChangeEvent<HTMLFormElement>) => {
    event.preventDefault()
    const formIsValid = event.currentTarget.checkValidity()

    if (!formIsValid) {
      setShowFormErrors(true)
      return
    }

    setSaving(true)

    try {
      const { id: hospitalId } = await api.addHospital({
        ...hospital,
        cnpj: removeAlphabeticCharacteres(hospital.cnpj),
      })

      navigate(`/hospitals/${hospitalId}`)
    } catch (error) {
      setAppMessage({
        show: true,
        success: false,
        message: `Erro ao adicionar o hospital: ${(error as any).messages.join(
          ', '
        )}`,
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <Page>
      <PageHeader
        back={{ to: '/hospitals', label: 'Hospitais' }}
        title="Adicionar hospital"
      />

      {appMessage.show && (
        <Alert
          variant="danger"
          onClose={() => setAppMessage({ show: false })}
          dismissible
        >
          {appMessage.message}
        </Alert>
      )}

      <HospitalForm
        hospital={hospital}
        onChange={(changes) => setHospital({ ...hospital, ...changes })}
        onSubmit={addHospital}
        validated={showFormErrors}
        saving={saving}
      />
    </Page>
  )
}

export default AddHospital
